class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
    setTimeout(function(){
      animateBar();
    },500);
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });

    this.refreshGwp();
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  refreshGwp(parsedState){
    if (this.dataset.gwpEnabled !== 'true') return;

    const variantId = this.dataset.gwpVariantId;
    const cart = document.querySelector('cart-drawer');
    const sectionId = document.getElementById('CartPage-CartItems')?.dataset?.id
    const section = parsedState?.sections?.cart || parsedState?.sections?.[sectionId]

    // update action
    if (section) {
      const parsedHtml = new DOMParser().parseFromString(section, 'text/html')
      const component =  parsedHtml.querySelector('cart-drawer-items') || parsedHtml.querySelector('cart-items');
      if (component) {
        this.dataset.gwpAction = component.getAttribute('data-gwp-action');
      }
    }

    switch(this.dataset.gwpAction) {
      case 'add': {
        const body = JSON.stringify({ 
          items: [{ id: variantId, quantity: 1, properties: { 'Free Gift': '__free-product' }}],
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname,
        });
        
        fetch(`${window.routes.cart_add_url}`, { ...{method: 'POST', headers: { 'Content-Type': 'application/json', Accept: `application/json` },}, ...{ body } })
          .then((data) => data.json())
          .then((data) => {
            if (window.location.pathname == '/cart') {
              this.getSectionsToRender().forEach((section) => {
                const elementToReplace =
                  document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                elementToReplace.innerHTML = this.getSectionInnerHTML(
                  data.sections[section.section],
                  section.selector
                );
              });
            } else {
              cart.renderContents(data);
            }
          })
        break;
      }

      case 'remove': {
        const body = JSON.stringify({ 
          id: variantId, quantity: 0,
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname,
        });
        fetch(`${window.routes.cart_change_url}`, { ...{method: 'POST', headers: { 'Content-Type': 'application/json', Accept: `application/json` },}, ...{ body } })
          .then((data) => data.json())
          .then((data) => {
            if (window.location.pathname == '/cart') {
              this.getSectionsToRender().forEach((section) => {
                const elementToReplace =
                  document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                elementToReplace.innerHTML = this.getSectionInnerHTML(
                  data.sections[section.section],
                  section.selector
                );
              });
              if (data.items.length === 0){
                cart.classList.add('is-empty');
              }
            } else {
              cart.renderContents(data); 
              if (data.items.length === 0){
                cart.classList.add('is-empty');
              }
            }
          })
        break;
      }

      case 'none':
      default:
        break;
    }
  
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('cart-items');
        this.innerHTML = sourceQty.innerHTML;
        this.refreshGwp();
        this.connectedCallback();
      })
      .catch(e => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents'
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.refreshGwp(parsedState);
        const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        publish(PUB_SUB_EVENTS.cartUpdate, {source: 'cart-items'});
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
          setTimeout(function(){
            animateBar();
          },500);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    setTimeout(function(){
            animateBar();
          },1000);
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
      constructor() {
        super();

      this.addEventListener('change', debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, ON_CHANGE_DEBOUNCE_TIMER))
      }
  });
};


setTimeout(function(){
    animateBar();
  },1500);
  function animateBar(){
    $('.range1 span').css("width", "0%");
    $('.range2 span').css("width", "0%");
    $('.range3 span').css("width", "0%");
    var s = $('.calculation--bar .current').data('ship');
    var p = $('.calculation--bar .current').data('reach');
    var sc = 100;
    jQuery.ajax({
      url:'/cart.js',
      type:'get',
      dataType:'json',
      async:false,
      success:function(d){   
        p = d.total_price;
        if(p == 0){
        $('.top_price').text('$ 0.00');
        $('.shipping_note').hide();
        }else{
          $('.shipping_note').show();
        }
      }
    });
  var total_price_total = p/100;
    var remain_shipping = s - total_price_total;
    var final_remain_shipping = remain_shipping.toFixed(2);
    
    if(total_price_total < s){
      $('.shipping_note_in').empty();
      $('.shipping_note_in').append('You are '+ final_remain_shipping +' away from FREE SHIPPING!');  
    }
    if(total_price_total > s){
      $('.shipping_note_in').empty();
      $('.shipping_note_in').append(`<strong>Congratulations!</strong> You've earned Free Shipping!`);
    }
    p = parseInt(p);
    var sc = p/s;
    
    var fp = $('.calculation--bar .current').data('total');
     
    $('.point .bull').removeClass('hvr-pop');
    if(sc <= 100){
      
        $('.current .range1 span').css('width', sc+'%');
        }else{
        $('.shipping .bull').addClass('hvr-bounce-in');
        $('.current .range1 span').css('width', 100+'%');
        setTimeout(function(){
            $('.point.shipping .bull').addClass('hvr-pop');
        }, 300);

        $('.current .range2 span').css('width', 100+'%');
        setTimeout(function(){
          $('.point.gift .bull').addClass('hvr-pop');
        }, 700)
        $('.current .range3 span').css('width', 100+'%');
    }
    p = p/100;
    
    if(c >= s){
     
      setTimeout(function(){
        $('.shipping .bull').removeClass('hvr-bounce-in');
        $('.shipping .bull').addClass('hvr-pop');
      }, 1000);
    }
}